
import paginationComponent from '../../components/pagination/pagination.component';
import { GOODMASTER_MAP_OBJECT, GOODMOVEMENT_MAP_OBJECT, } from '../../config/constants';
import languageModel from '../../models/language.model';
import POSMAuthorizationModel, { POSM_PERMISSION_KEY } from '../../models/posm/posm-authority.model';
import { DESCENDING_TEXT } from '../../models/posm/posm.constant';
import ViewBase from '../view-base.view';
export default function DisplayAllGoodmaster() {
  ViewBase.call(this);
  let listGoodMovement = [];
  const parseListGoodMovement = (goodMovementList) => {
    return goodMovementList?.map(item => {
      if (!item) {
        return;
      }
      let warehouses = [];
      for (let props in item) {
        if (!Object.hasOwn(GOODMASTER_MAP_OBJECT, props)) {
          warehouses.push([props, item[props]])
        }
      }
      let newItem = { ...item, warehouses: warehouses }
      return newItem
    })
  }
  const createTableHeader = (listGoodMovement, index) => {
    if (!listGoodMovement.length) {
      return
    }
    const goodMovementObj = listGoodMovement[index];
    let tableHeaders = [];
    for (let props in GOODMASTER_MAP_OBJECT) {
      if (GOODMASTER_MAP_OBJECT[props]) {
        tableHeaders.push([props, GOODMOVEMENT_MAP_OBJECT[props]])
      }
      if (props == "StockValue") {
        goodMovementObj.warehouses.map((item) => {
          tableHeaders.push(["Warehouse", item[0]])
        })
      }
    }
    return tableHeaders;
  }

  const _getSortIcon = (selectedOrderBy, selectedSortBy, sortBy) => {
    if (selectedSortBy !== sortBy) {
      return null
    }
    return selectedOrderBy === DESCENDING_TEXT ? m('i.bi.bi-sort-down') : m('i.bi.bi-sort-up')
  }
  return {

    oninit: () => {

    },
    view: (vnode) => {
      listGoodMovement = vnode.attrs.listGoodMovement || [];

      listGoodMovement = parseListGoodMovement(listGoodMovement)
      let height = listGoodMovement?.length > 10 ? "1000px" : "650px";
      return [
        m('.row',
          m('.col-12.attendance',
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.gap-3.mb-2',
                  m('a.btn.btn-primary',
                    {
                      class: listGoodMovement?.length > 0 ? '' : 'disabled',
                      onclick: () => {
                        vnode.attrs.resetPagination()
                        vnode.attrs.onDownLoadGoodMaster()
                      }
                    },
                    m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                  ),

                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive", { "style": `height : ${height}` },
                      m("table.table.table-hover.table-bordered", [
                        m("thead.thead-bggrey", { "style": "position : sticky ; top :1px; box-shadow: 0px -1px var(--is-link-blue)" },

                          m("tr.align-middle", { style: 'box-shadow: 0px 1px var(--blue-color-light)' }, [
                            m("th", { "scope": "col", "colspan": "9" }),
                            m("th", { "scope": "col", "colspan": listGoodMovement[0]?.warehouses.length, "style": "text-align :center;" }, "Warehouse"),
                            m("th", { "scope": "col", "colspan": "15" }),
                          ]),
                          m("tr.align-middle", createTableHeader(listGoodMovement, 0)?.map((item) => {
                            if (Object.hasOwn(GOODMASTER_MAP_OBJECT, item[0])) {
                              return m("th.cursor-pointer", {
                                "style": "max-width : 320px",
                                onclick: () => { vnode.attrs.onSortClick(item[0]) },
                              },
                                _getSortIcon(vnode.attrs.sortObj.orderBy, vnode.attrs.sortObj.sortBy, item[0]),
                                this.getText(GOODMASTER_MAP_OBJECT[item[0]].code, GOODMASTER_MAP_OBJECT[item[0]].apiProps)
                              )
                            } else {
                              return m("th.text-truncate.cursor-pointer", {
                                title: item[1],
                                "style": "max-width : 320px",
                                onclick: () => { vnode.attrs.onSortClick(item[1]) },
                              },
                                _getSortIcon(vnode.attrs.sortObj.orderBy, vnode.attrs.sortObj.sortBy, item[1]),
                                item[1]
                              )
                            }
                          }))
                        ),
                        m("tbody",
                          (listGoodMovement.length === 0) &&
                          m("tr", { "class": "align-middle" },
                            m("td", { "colspan": 27 }, languageModel.getText("EM00000141", "No records found."))
                          ),
                          listGoodMovement.length > 0 &&
                          listGoodMovement.map((att, index) => {
                            return [
                              m("tr.align-middle", createTableHeader(listGoodMovement, index)?.map((item) => {
                                // if (item[1] == "Date") {
                                //   return m("td", moment(att[item[0]], formats.apiDateFormat).format(formats.dateFormat))
                                // }
                                if (item[0] == "Warehouse") {
                                  return m("td", att[item[1]])
                                }

                                if ((item[0] == "MvgPrice" || item[0] == "StockValue") && !POSMAuthorizationModel.isPosmAuthorized(POSM_PERMISSION_KEY.SHOW_PRICING_INFO)) {
                                  return m("td.text-truncate", { title: att[item[0]], "style": "max-width : 400px" }, "")
                                }
                                return m("td.text-truncate", { title: att[item[0]], "style": "max-width : 400px" }, att[item[0]])


                              })),
                            ]

                          }),
                        )
                      ])
                    ),
                    listGoodMovement.length > 0 &&
                    m(".px-3",
                      m(paginationComponent, {
                        currentPage: vnode.attrs.paginationObj?.pageIndex || 1,
                        pageSize: vnode.attrs.paginationObj?.pageSize || 1,
                        totalItems: vnode.attrs.totalItems || 1,
                        onPageChanged: (pageIndex) => {
                          vnode.attrs.setPaginationObj({ pageIndex })
                          vnode.attrs.onSearchForGoodMasterList();
                        },
                        onPageSizeChanged: (pageIndex, pageSize) => {
                          vnode.attrs.setPaginationObj({ pageIndex, pageSize });
                          vnode.attrs.onSearchForGoodMasterList();
                        },
                      })
                    )
                  )
                )
              )
            )
            //End List
          ),
        ),

        // isExcelDownloadModalOpen &&
        // m(Dialog, {
        //   class: 'modal-body-overflow-visible',
        //   closeOnOutsideClick: false,
        //   isOpen: isExcelDownloadModalOpen,
        //   onClose: closeExcelDownloadModal,
        //   title: this.getText('LT00000741', 'Attendance Download'),
        //   content: m(AttendanceExcelDownloadView, {
        //     data: [],
        //     onClose: (o) => { isExcelDownloadModalOpen = o; },
        //   }),
        // }),
        // this.getBaseViews()
      ];
    },
  };
}
